import * as actions from '../actions/types';
import { messages } from '../config/constants';

const defaultAppState = {
  // flags
  isAuthenticated: false,
  isCredentialsSet: false,
  isLoginComplete: false,
  error: false,

  // action states
  isAuthenticating: false,
  isFetchingCredentials: false,
  userSet: false,

  // variables
  user: {},
  warningMessage: '',
  errorMessage: '',
  statusMessage: ''
};

function logoutSuccess() {
  return defaultAppState;
}

function authRequest(authState, action) {
  return {
    ...authState,
    isAuthenticating: true,
    isAuthenticated: false
  };
}

function authSuccess(authState, action) {
  return {
    ...authState,
    isAuthenticating: false,
    isAuthenticated: true,
    errorMessage: '',
    error: false
  };
}

function authFailure(authState, action) {
  return {
    ...authState,
    isAuthenticating: false,
    isAuthenticated: false,
    errorMessage: action.message,
    error: true
  };
}

function credentialsRequest(authState) {
  return {
    ...authState,
    isFetchingCredentials: true,
    isCredentialsSet: false,
    statusMessage: messages.CREDENTIALS_REQUEST
  };
}

function credentialsSuccess(authState) {
  return {
    ...authState,
    isFetchingCredentials: false,
    isCredentialsSet: true,
    isLoginComplete: authState.isAuthenticated,
    errorMessage: '',
    error: false,
    statusMessage: authState.isAuthenticated ? messages.LOGIN_COMPLETE : messages.CREDENTIALS_SUCCESS
  };
}

function credentialsFailure(authState, action) {
  return {
    ...authState,
    isFetchingCredentials: false,
    isCredentialsSet: false,
    isLoginComplete: false,
    errorMessage: action.message,
    error: true
  }
}

function setUser(authState, action){
  let { user } = action;
  return {
    ...authState,
    user,
    userSet: true
  }
}

function addApplicationToUser(authState, action) {
  const { applicationId, periodId, studentId } = action.application;
  return {
    ...authState,
    user: {
      ...authState.user,
      applications: [
        ...authState.user.applications,
        {
          periodId,
          applicationId,
          studentId
        }
      ]
    }
  }
}

export const authReducer = (state = defaultAppState, action) => {
  switch (action.type) {
    case actions.LOGOUT_SUCCESS: return logoutSuccess(state, action);
    case actions.AUTH_REQUEST: return authRequest(state, action);
    case actions.AUTH_SUCCESS: return authSuccess(state, action);
    case actions.AUTH_FAILURE: return authFailure(state, action);
    case actions.CREDENTIALS_REQUEST: return credentialsRequest(state);
    case actions.CREDENTIALS_SUCCESS: return credentialsSuccess(state);
    case actions.CREDENTIALS_FAILURE: return credentialsFailure(state, action);
    case actions.SET_USER: return setUser(state, action);
    case actions.CREATE_APPLICATION_SUCCESS: return addApplicationToUser(state, action);
    default: return state
  }
};

export default authReducer;